module.exports = __webpack_public_path__ + "static/media/why.8b090a26.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/why.gif
// module id = 89
// module chunks = 0